<template>
    <div class="color-table">
        <el-button type="primary" :icon="Plus" @click="addColor" size="small">新增</el-button>
        <table class="data-field-table mb-10">
			<tr>
				<td style="width: 20px"></td>
				<td class="text xs info form-input-type">颜色</td>
				<td class="text xs info">渐变色</td>
				<td class="text xs info">位置</td>
				<td class="text xs info" style="width: 100px">操作</td>
			</tr>
			<tbody>
				<tr
					v-for="(item, index) in modelValue"
					:key="item.id"
					@dragover.stop.prevent
					@drop.stop.prevent="
						(e) => {
							drop(e, index);
						}
					"
					draggable="true"
					@dragstart="
						(e) => {
							handleDragStart(e, index);
						}
					"
				>
					<td>
						<i title="移动" class="iconfont icon-move move text"></i>
					</td>
					<td>
						<!-- <el-input v-model="item.name" clearable></el-input> -->
                        <div :style="`background-color: ${item.color1}`" class="colorPan"></div>
					</td>
					<td>
						<div :style="`background-color: ${item.color2}`" class="colorPan"></div>
					</td>
                    <td class="text xs info">
                        <data>{{item.postion}}</data>
                    </td>
					<td>
                        <div>
                            <i title="编辑" class="el-icon-edit cursor text mr-4" @click="showDetail(item)"></i>
						    <i title="删除" class="el-icon-delete cursor text" @click="deleteColor(index)"></i>
                        </div>
					</td>
				</tr>
			</tbody>
		</table>
    </div>
    <el-dialog v-model="dialogVisible" :title="dialogTitle" destroy-on-close width="400px">
        <el-form label-width="80px">
            <el-form-item label="颜色">
                <colorPicker v-model="colorDetail.color1"></colorPicker>
            </el-form-item>
            <el-form-item label="渐变色">
                <colorPicker v-model="colorDetail.color2"></colorPicker>
            </el-form-item>
            <el-form-item label="位置">
                <el-input-number v-model="colorDetail.postion" :min="0" :max="100" size="small" />
            </el-form-item>
        </el-form>
        <template #footer v-if="dialogTitle == '新建'">
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="saveColor">
                    新增
                </el-button>
            </div>
        </template>
    </el-dialog>
</template>
<script>
import { Plus, Edit, Delete } from '@element-plus/icons-vue'
import colorPicker from './color-picker.vue';
export default {
    data() {
        return {
            Plus: Plus,
            Delete: Delete,
            Edit: Edit,
            dialogVisible: false,
            dialogTitle: '编辑',
            colorDetail: {}
        }
    },
    components: { colorPicker },
    props: {
        modelValue: {
            type: Object
        }
    },
    methods: {
        addColor() {
            this.colorDetail = {}
            this.dialogTitle = '新建'
            this.dialogVisible = true;
        },
        showDetail(data) {
            this.dialogVisible = true;
            this.dialogTitle = '编辑';
            this.colorDetail = {}
            this.colorDetail = data;
        },
        deleteColor(index) {
            this.modelValue.splice(index, 1);
        },
        saveColor() {
            this.dialogVisible = false;
            this.modelValue.push(this.colorDetail)
        },
        handleDragStart(e, index) {
            e.dataTransfer.setData("text/plain", index);
        },
        drop(e, i) {
            let index = e.dataTransfer.getData("text/plain");
            let temp = this.modelValue[index];
            this.modelValue[index] = this.modelValue[i];
            this.modelValue[i] = temp;
        },
    }
}
</script>
<style scoped>
.colorPan {
    width: 30px;
    height: 30px;
    border-radius: 2px;
    margin: 0 auto;
}

.data-field-table {
    th,
    tr,
    td {
        color: var(--el-text-color-regular);
    }
}
i[class*="el-icon-"] {
    font-family: "iconfont" !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
.el-icon-edit:before {
    content: "\e8ac";
}

.el-icon-delete:before {
    content: "\e68e";
}

.el-icon-delete,
.el-icon-edit {
    cursor: pointer;
    color: #3e7aff;
}
</style>